<template>
  <div class="important-page-c display--flex fd--column">
    <!-- 搜索 -->
    <div class="search-form btn-2b5a95">
      <div
        class="l-w"
        :style="{
          height: $store.state.global.isSearchExtend_1
            ? ''
            : $store.state.global.searchFormHeight_1 + 10 + 'px',
        }"
      >
        <el-form
          label-position="right"
          :class="
            $store.state.global.isSearchExtend_1 ? '' : 'overflow--hidden'
          "
					 @submit.native.prevent
					 :model="searchForm"
        >
          <el-form-item label="审核人1:">
          	<el-input 
							v-model.trim="searchForm.username1" 
							@keyup.enter.native="search" 
							clearable/>
          </el-form-item>
          <el-form-item label="审核人2:">
          	<el-input 
							v-model.trim="searchForm.username2" 
							@keyup.enter.native="search" 
							clearable />
          </el-form-item>
					<el-form-item label="审核类型:" prop="type">
					  <el-select 
							v-model="searchForm.type" 
							@keyup.enter.native="search" 
							@visible-change="visibleType"
							ref="selectref"
							clearable>
					    <el-option
					      v-for="(item, index) in approvalTypeList"
					      :key="index"
					      :label="item.val"
					      :value="item.key"
								@keyup.enter.native="search" 
					    />
					  </el-select>
					</el-form-item>
          <el-form-item label="所属教学点名称:">
            <el-input 
							v-model.trim="searchForm.schoolorgname"
							@keyup.enter.native="search"
							clearable />
          </el-form-item>
					<el-form-item label="审核人3:">
						<el-input 
							v-model.trim="searchForm.username3" 
							@keyup.enter.native="search" 
							clearable/>
					</el-form-item>
					<el-form-item label="审核人4:">
						<el-input 
							v-model.trim="searchForm.username4" 
							@keyup.enter.native="search" 
							clearable />
					</el-form-item>
					<el-form-item label="审核人5:">
						<el-input 
							v-model.trim="searchForm.username5" 
							@keyup.enter.native="search" 
							clearable/>
					</el-form-item>
					<el-form-item label="审核人6:">
						<el-input 
							v-model.trim="searchForm.username6" 
							@keyup.enter.native="search" 
							clearable />
					</el-form-item>
					<el-form-item label="审核人7:">
						<el-input 
							v-model.trim="searchForm.username7" 
							@keyup.enter.native="search" 
							clearable/>
					</el-form-item>
					<el-form-item label="审核人8:">
						<el-input 
							v-model.trim="searchForm.username8" 
							@keyup.enter.native="search" 
							clearable />
					</el-form-item>
        </el-form>
      </div>
      <div class="r-w">
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="search"
          :loading="!$store.state.global.isEndRequest"
          class="btn-2b5a95"
          >搜索</el-button
        >
				<el-button
					type="primary"
					@click="resetQuery"
					class="btn-2b5a95"
				>
					重置
				</el-button>
        <el-button
          type="primary"
          :icon="
            $store.state.global.isSearchExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          v-if="$store.state.global.searchExtend_1"
          class="btn-2b5a95"
          @click="onExtendClick('isSearchExtend_1')"
          >{{ $store.state.global.searchExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 按钮操作 -->
    <div
      class="Btn-w eaf4ff-btn"
      v-if="tableRes.buttonlist && tableRes.buttonlist.length"
      :style="{
        height: $store.state.global.isBtnExtend_1
          ? ''
          : $store.state.global.BtnHeight_1 + 10 + 'px',
      }"
    >
      <div
        class="btn-l"
        v-if="tableRes.buttonlist"
        :class="$store.state.global.isBtnExtend_1 ? '' : 'overflow--hidden'"
      >
        <el-button
          v-for="(item, index) in tableRes.buttonlist"
          :key="index"
          type="primary"
          @click="onClickBtn(item.buttonname)"
          >{{ item.name }}
        </el-button>
      </div>
      <div class="Btn-extend">
        <el-button
          type="primary"
          v-if="$store.state.global.btnExtend_1"
          class="btn-2b5a95"
          :icon="
            $store.state.global.isBtnExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          @click="onExtendClick('isBtnExtend_1')"
          >{{ $store.state.global.BtnExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    	<el-table
				stripe
				border
				:header-cell-style="{ background: '#044d8c', color: '#fff'}"
    		:data="tableRes.list"
    		ref="multipleTable"
    		style="width: 100%"
    		@selection-change="handleSelectionChange"
    	>
    		<el-table-column type="selection" width="55" align="center" />
    		<el-table-column align="center"  label="流水号" prop="id"/>
    		<el-table-column align="center"  label="审核人1" prop="username1"/>
    		<el-table-column align="center"  label="审核人2" prop="username2"/>
    		<el-table-column align="center"  label="审核人3" prop="username3"/>
    		<el-table-column align="center"  label="审核人4" prop="username4"/>
				<el-table-column align="center"  label="审核人5" prop="username5"/>
				<el-table-column align="center"  label="审核人6" prop="username6"/>
				<el-table-column align="center"  label="审核人7" prop="username7"/>
				<el-table-column align="center"  label="审核人8" prop="username8"/>
    		<el-table-column align="center"  label="审核类型" prop="type">
					<template slot-scope="scope">
					  {{ examin[scope.row.type] }}
					</template>
				</el-table-column>
    		<el-table-column align="center"  label="所属教学点名称" prop="schoolorgname"/>
    		
    	</el-table>
    <!-- 	分页 -->
    	<el-pagination
    		background
    		@current-change="handleCurrentChange"
    		:current-page="pageinfo.pageindex"
    		:page-size="pageinfo.pagesize"
    		:page-sizes="[10, 20, 30, 40, 50]"
    		layout="total, prev, pager, next, jumper"
    		:total="tableRes.totalcount"
    	>
    	</el-pagination>
			<!-- 增加,修改 -->
			<el-dialog
			  class="btn-2b5a95"
				v-dialogDrag
			  width="50%"
				:title="dialogTitle"
				:close-on-click-modal='false'
			  :visible.sync="showAddModal"
			  v-if="showAddModal"
			  append-to-body
			>
			  <el-form
			    :model="dynamicValidateForm"
			    ref="dynamicValidateForm"
			    label-width="100px"
			    class="demo-dynamic form-item-w-100"
			    status-icon
			    :rules="rules"
			  >
			    <el-form-item prop="companyorgname" label="所属分公司:">
			    	<el-select
			    		v-model="dynamicValidateForm.companyorgname"
			    		placeholder="请选择"
			    		:disabled="!$store.state.login.isMaxAuth"
			    		clearable
			    		@change="onChangeCompany($event, 'dynamicValidateForm')"
			    	>
			    		<el-option
			    			v-for="item in $store.state.selectData.companyList"
			    			:key="item.key"
			    			:label="item.val"
			    			:value="item.key"
			    		></el-option>
			    	</el-select>
			    </el-form-item>
			    <el-form-item prop="schoolorgname" label="所属教学点:">
			    	<el-select
			    		v-model="dynamicValidateForm.schoolorgname"
			    		placeholder="请选择"
			    		clearable
			    		@change="onChangeSchool($event, 'dynamicValidateForm')"
			    	>
			    		<el-option
			    			v-for="item in $store.state.selectData.schoolList"
			    			:key="item.key"
			    			:label="item.val"
			    			:value="item.key"
			    		></el-option>
			    	</el-select>
			    </el-form-item>
					<el-form-item label="审核人1:" prop="username1">
						<el-input v-model="dynamicValidateForm.username1" disabled/>
						<el-button 
							type="primary"
						  class="select-btn"
						  @click="
						    onSelectData(user_dialogresult, 'showInusernameModal')
						  "
						  >选择</el-button
						>
					</el-form-item>
					<el-form-item prop="username2" label="审核人2:">
						<el-input v-model="dynamicValidateForm.username2" disabled/>
						<el-button 
							type="primary"
						  class="select-btn"
						  @click="
						    onSelectData(user_dialogresult, 'showInusernameModal2')
						  "
						  >选择</el-button
						>
					</el-form-item>
					<el-form-item prop="username3" label="审核人3:">
						<el-input v-model="dynamicValidateForm.username3" disabled/>
						<el-button 
							type="primary"
						  class="select-btn"
						  @click="
						    onSelectData(user_dialogresult, 'showInusernameModal3')
						  "
						  >选择</el-button
						>
					</el-form-item>
					<el-form-item prop="username4" label="审核人4:">
						<el-input v-model="dynamicValidateForm.username4" disabled/>
						<el-button 
							type="primary"
						  class="select-btn"
						  @click="
						    onSelectData(user_dialogresult, 'showInusernameModal4')
						  "
						  >选择</el-button
						>
					</el-form-item>
					
					<el-form-item label="审核人5:">
						<el-input v-model="dynamicValidateForm.username5" disabled/>
						<el-button 
							type="primary"
						  class="select-btn"
						  @click="
						    onSelectData(user_dialogresult, 'showInusernameModal5')
						  "
						  >选择</el-button
						>
					</el-form-item>
					<el-form-item label="审核人6:">
						<el-input v-model="dynamicValidateForm.username6" disabled/>
						<el-button 
							type="primary"
						  class="select-btn"
						  @click="
						    onSelectData(user_dialogresult, 'showInusernameModal6')
						  "
						  >选择</el-button
						>
					</el-form-item>
					<el-form-item label="审核人7:">
						<el-input v-model="dynamicValidateForm.username7" disabled/>
						<el-button 
							type="primary"
						  class="select-btn"
						  @click="
						    onSelectData(user_dialogresult, 'showInusernameModal7')
						  "
						  >选择</el-button
						>
					</el-form-item>
					<el-form-item label="审核人8:">
						<el-input v-model="dynamicValidateForm.username8" disabled/>
						<el-button 
							type="primary"
						  class="select-btn"
						  @click="
						    onSelectData(user_dialogresult, 'showInusernameModal8')
						  "
						  >选择</el-button
						>
					</el-form-item>
			    <el-form-item label="审核类型:" prop="type">
			      <el-select 
			    		v-model="dynamicValidateForm.type" 
			    		clearable>
			        <el-option
			          v-for="(item, index) in approvalTypeList"
			          :key="index"
			          :label="item.val"
			          :value="item.key"
			        />
			      </el-select>
			    </el-form-item>
			  </el-form>
			  <span slot="footer" class="dialog-footer">
			    <el-button
			      type="primary"
			      @click="submitAddOrEditForm('dynamicValidateForm')"
			      :loading="!$store.state.global.isEndRequest"
			      >提交
			    </el-button>
			  </span>
			</el-dialog>
			<!-- 选择审核人 -->
			<el-dialog
			  class="btn-2b5a95"
			  width="50%"
				v-dialogDrag
				:close-on-click-modal='false'
			  @close="onCloseSelect"
			  title="选择审核人"
			  :visible.sync="showInusernameModal"
			  v-if="showInusernameModal"
			  append-to-body
			>
			  <el-button
			    type="primary"
			    @click="onConfirmInusername('showInusernameModal')"
			    >确定</el-button
			  >
			
			  <div class="index_2 btn-2b5a95">
			    <div
			      class="l-w"
			      :style="{
			        height: $store.state.global.isSearchExtend_2
			          ? ''
			          : $store.state.global.searchFormHeight_2 + 10 + 'px',
			      }"
			    >
			      <el-form
			        label-position="right"
			        :class="
			          $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
			        "
			        :model="selectSearchForm"
							@submit.native.prevent
			      >
			        <el-form-item label="真实姓名:" prop="realname">
			          <el-input 
			        		v-model.trim="selectSearchForm.realname" 
			        		@keyup.enter.native="onSelectSearchClick(
			            selectTableUrl,
			            null,
			            Object.assign({}, selectSearchForm)
			          )"
			        		clearable />
			        </el-form-item>
			      </el-form>
			    </div>
			    <div class="r-w">
			      <el-button
			        type="primary"
			        icon="el-icon-search"
			        :loading="!$store.state.global.isEndRequest"
			        class="btn-2b5a95"
			        @click="onSelectSearchClick(
			            selectTableUrl,
			            null,
			            Object.assign({}, selectSearchForm)
			          )"
			        >搜索</el-button
			      >
						<el-button type="primary" @click="handleQuery">重置</el-button>
			      <el-button
			        type="primary"
			        :icon="
			          $store.state.global.isSearchExtend_2
			            ? 'el-icon-arrow-up'
			            : 'el-icon-arrow-down'
			        "
			        v-if="$store.state.global.searchExtend_2"
			        class="btn-2b5a95"
			        @click="onExtendClick('isSearchExtend_2')"
			        >{{ $store.state.global.searchExtendText_2 }}</el-button
			      >
			    </div>
			  </div>
			
			  <el-table
			    :data="selectTable.list"
			    style="width: 100%"
			    ref="moneyTable"
					:key="key"
			    @selection-change="handleSelectionChange"
			  >
			    <el-table-column type="selection" width="55" />
			    <el-table-column label="流水号" prop="id" align="center" />
			    <el-table-column label="真实姓名" prop="realname" align="center" />
			    <el-table-column label="所属部门" prop="departorgname" align="center" />
			    <el-table-column
			      label="所属教学点"
			      prop="schoolorgname"
			      align="center"
			    />
			  </el-table>
			  <el-pagination
			    background
			    @current-change="
			     (val, data) =>
			         handleSelectChange(val, Object.assign({}, selectSearchForm))
			     "
			    :current-page="selectPageInfo.pageindex"
			    :page-size="selectPageInfo.pagesize"
			    :page-sizes="[10, 20, 30, 40, 50]"
			    layout="total, prev, pager, next, jumper"
			    :total="selectTable.totalcount"
			  ></el-pagination>
			</el-dialog>
			<!-- 选择审核人2 -->
			<el-dialog
			  class="btn-2b5a95"
			  width="50%"
				v-dialogDrag
			  @close="onCloseSelect"
			  title="选择审核人"
				:close-on-click-modal='false'
			  :visible.sync="showInusernameModal2"
			  v-if="showInusernameModal2"
			  append-to-body
			>
			  <el-button
			    type="primary"
			    @click="onConfirmInusername2('showInusernameModal')"
			    >确定</el-button
			  >
			
			  <div class="index_2 btn-2b5a95">
			    <div
			      class="l-w"
			      :style="{
			        height: $store.state.global.isSearchExtend_2
			          ? ''
			          : $store.state.global.searchFormHeight_2 + 10 + 'px',
			      }"
			    >
			      <el-form
			        label-position="right"
			        :class="
			          $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
			        "
			        :model="selectSearchForm"
							@submit.native.prevent
			      >
			        <el-form-item label="真实姓名:" prop="realname">
			          <el-input 
			        		v-model.trim="selectSearchForm.realname" 
			        		@keyup.enter.native="onSelectSearchClick(
			            selectTableUrl,
			            null,
			            Object.assign({}, selectSearchForm)
			          )"
			        		clearable />
			        </el-form-item>
			      </el-form>
			    </div>
			    <div class="r-w">
			      <el-button
			        type="primary"
			        icon="el-icon-search"
			        :loading="!$store.state.global.isEndRequest"
			        class="btn-2b5a95"
			        @click="onSelectSearchClick(
			            selectTableUrl,
			            null,
			            Object.assign({}, selectSearchForm)
			          )"
			        >搜索</el-button
			      >
						<el-button type="primary" @click="handleQuery">重置</el-button>
			      <el-button
			        type="primary"
			        :icon="
			          $store.state.global.isSearchExtend_2
			            ? 'el-icon-arrow-up'
			            : 'el-icon-arrow-down'
			        "
			        v-if="$store.state.global.searchExtend_2"
			        class="btn-2b5a95"
			        @click="onExtendClick('isSearchExtend_2')"
			        >{{ $store.state.global.searchExtendText_2 }}</el-button
			      >
			    </div>
			  </div>
			
			  <el-table
			    :data="selectTable.list"
			    style="width: 100%"
			    ref="moneyTable"
					:key="key"
			    @selection-change="handleSelectionChange"
			  >
			    <el-table-column type="selection" width="55" />
			    <el-table-column label="流水号" prop="id" align="center" />
			    <el-table-column label="真实姓名" prop="realname" align="center" />
			    <el-table-column label="所属部门" prop="departorgname" align="center" />
			    <el-table-column
			      label="所属教学点"
			      prop="schoolorgname"
			      align="center"
			    />
			  </el-table>
			  <el-pagination
			    background
			    @current-change="
			     (val, data) =>
			         handleSelectChange(val, Object.assign({}, selectSearchForm))
			     "
			    :current-page="selectPageInfo.pageindex"
			    :page-size="selectPageInfo.pagesize"
			    :page-sizes="[10, 20, 30, 40, 50]"
			    layout="total, prev, pager, next, jumper"
			    :total="selectTable.totalcount"
			  ></el-pagination>
			</el-dialog>
			<!-- 选择审核人3 -->
			<el-dialog
			  class="btn-2b5a95"
			  width="50%"
				v-dialogDrag
				:close-on-click-modal='false'
			  @close="onCloseSelect"
			  title="选择审核人"
			  :visible.sync="showInusernameModal3"
			  v-if="showInusernameModal3"
			  append-to-body
			>
			  <el-button
			    type="primary"
			    @click="onConfirmInusername3('showInusernameModal')"
			    >确定</el-button
			  >
			
			  <div class="index_2 btn-2b5a95">
			    <div
			      class="l-w"
			      :style="{
			        height: $store.state.global.isSearchExtend_2
			          ? ''
			          : $store.state.global.searchFormHeight_2 + 10 + 'px',
			      }"
			    >
			      <el-form
			        label-position="right"
			        :class="
			          $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
			        "
			        :model="selectSearchForm"
							@submit.native.prevent
			      >
			        <el-form-item label="真实姓名:" prop="realname">
			          <el-input 
									v-model.trim="selectSearchForm.realname" 
									@keyup.enter.native="onSelectSearchClick(
			            selectTableUrl,
			            null,
			            Object.assign({}, selectSearchForm)
			          )"
									clearable />
			        </el-form-item>
			      </el-form>
			    </div>
			    <div class="r-w">
			      <el-button
			        type="primary"
			        icon="el-icon-search"
			        :loading="!$store.state.global.isEndRequest"
			        class="btn-2b5a95"
			        @click="onSelectSearchClick(
			            selectTableUrl,
			            null,
			            Object.assign({}, selectSearchForm)
			          )"
			        >搜索</el-button
			      >
						<el-button type="primary" @click="handleQuery">重置</el-button>
			      <el-button
			        type="primary"
			        :icon="
			          $store.state.global.isSearchExtend_2
			            ? 'el-icon-arrow-up'
			            : 'el-icon-arrow-down'
			        "
			        v-if="$store.state.global.searchExtend_2"
			        class="btn-2b5a95"
			        @click="onExtendClick('isSearchExtend_2')"
			        >{{ $store.state.global.searchExtendText_2 }}</el-button
			      >
			    </div>
			  </div>
			
			  <el-table
			    :data="selectTable.list"
			    style="width: 100%"
			    ref="moneyTable"
					:key="key"
			    @selection-change="handleSelectionChange"
			  >
			    <el-table-column type="selection" width="55" />
			    <el-table-column label="流水号" prop="id" align="center" />
			    <el-table-column label="真实姓名" prop="realname" align="center" />
			    <el-table-column label="所属部门" prop="departorgname" align="center" />
			    <el-table-column
			      label="所属教学点"
			      prop="schoolorgname"
			      align="center"
			    />
			  </el-table>
			  <el-pagination
			    background
			    @current-change="
			     (val, data) =>
			         handleSelectChange(val, Object.assign({}, selectSearchForm))
			     "
			    :current-page="selectPageInfo.pageindex"
			    :page-size="selectPageInfo.pagesize"
			    :page-sizes="[10, 20, 30, 40, 50]"
			    layout="total, prev, pager, next, jumper"
			    :total="selectTable.totalcount"
			  ></el-pagination>
			</el-dialog>
			<!-- 选择审核人4 -->
			<el-dialog
			  class="btn-2b5a95"
			  width="50%"
				v-dialogDrag
				:close-on-click-modal='false'
			  @close="onCloseSelect"
			  title="选择审核人"
			  :visible.sync="showInusernameModal4"
			  v-if="showInusernameModal4"
			  append-to-body
			>
			  <el-button
			    type="primary"
			    @click="onConfirmInusername4('showInusernameModal')"
			    >确定</el-button
			  >
			
			  <div class="index_2 btn-2b5a95">
			    <div
			      class="l-w"
			      :style="{
			        height: $store.state.global.isSearchExtend_2
			          ? ''
			          : $store.state.global.searchFormHeight_2 + 10 + 'px',
			      }"
			    >
			      <el-form
			        label-position="right"
			        :class="
			          $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
			        "
			        :model="selectSearchForm"
							@submit.native.prevent
			      >
			        <el-form-item label="真实姓名:" prop="realname">
			          <el-input 
			        		v-model.trim="selectSearchForm.realname" 
			        		@keyup.enter.native="onSelectSearchClick(
			            selectTableUrl,
			            null,
			            Object.assign({}, selectSearchForm)
			          )"
			        		clearable />
			        </el-form-item>
			      </el-form>
			    </div>
			    <div class="r-w">
			      <el-button
			        type="primary"
			        icon="el-icon-search"
			        :loading="!$store.state.global.isEndRequest"
			        class="btn-2b5a95"
			        @click="onSelectSearchClick(
			            selectTableUrl,
			            null,
			            Object.assign({}, selectSearchForm)
			          )"
			        >搜索</el-button
			      >
						<el-button type="primary" @click="handleQuery">重置</el-button>
			      <el-button
			        type="primary"
			        :icon="
			          $store.state.global.isSearchExtend_2
			            ? 'el-icon-arrow-up'
			            : 'el-icon-arrow-down'
			        "
			        v-if="$store.state.global.searchExtend_2"
			        class="btn-2b5a95"
			        @click="onExtendClick('isSearchExtend_2')"
			        >{{ $store.state.global.searchExtendText_2 }}</el-button
			      >
			    </div>
			  </div>
			
			  <el-table
			    :data="selectTable.list"
			    style="width: 100%"
			    ref="moneyTable"
					:key="key"
			    @selection-change="handleSelectionChange"
			  >
			    <el-table-column type="selection" width="55" />
			    <el-table-column label="流水号" prop="id" align="center" />
			    <el-table-column label="真实姓名" prop="realname" align="center" />
			    <el-table-column label="所属部门" prop="departorgname" align="center" />
			    <el-table-column
			      label="所属教学点"
			      prop="schoolorgname"
			      align="center"
			    />
			  </el-table>
			  <el-pagination
			    background
			    @current-change="
			     (val, data) =>
			         handleSelectChange(val, Object.assign({}, selectSearchForm))
			     "
			    :current-page="selectPageInfo.pageindex"
			    :page-size="selectPageInfo.pagesize"
			    :page-sizes="[10, 20, 30, 40, 50]"
			    layout="total, prev, pager, next, jumper"
			    :total="selectTable.totalcount"
			  ></el-pagination>
			</el-dialog>
			
			
			<!-- 审核人5 -->
			<el-dialog
			  class="btn-2b5a95"
			  width="50%"
				v-dialogDrag
			  @close="onCloseSelect"
			  title="选择审核人"
				:close-on-click-modal='false'
			  :visible.sync="showInusernameModal5"
			  v-if="showInusernameModal5"
			  append-to-body
			>
			  <el-button
			    type="primary"
			    @click="onConfirmInusername5('showInusernameModal5')"
			    >确定</el-button
			  >
			
			  <div class="index_2 btn-2b5a95">
			    <div
			      class="l-w"
			      :style="{
			        height: $store.state.global.isSearchExtend_2
			          ? ''
			          : $store.state.global.searchFormHeight_2 + 10 + 'px',
			      }"
			    >
			      <el-form
			        label-position="right"
			        :class="
			          $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
			        "
			        :model="selectSearchForm"
							@submit.native.prevent
			      >
			        <el-form-item label="真实姓名:" prop="realname">
			          <el-input 
			        		v-model.trim="selectSearchForm.realname" 
			        		@keyup.enter.native="onSelectSearchClick(
			            selectTableUrl,
			            null,
			            Object.assign({}, selectSearchForm)
			          )"
			        		clearable />
			        </el-form-item>
			      </el-form>
			    </div>
			    <div class="r-w">
			      <el-button
			        type="primary"
			        icon="el-icon-search"
			        :loading="!$store.state.global.isEndRequest"
			        class="btn-2b5a95"
			        @click="onSelectSearchClick(
			            selectTableUrl,
			            null,
			            Object.assign({}, selectSearchForm)
			          )"
			        >搜索</el-button
			      >
						<el-button type="primary" @click="handleQuery">重置</el-button>
			      <el-button
			        type="primary"
			        :icon="
			          $store.state.global.isSearchExtend_2
			            ? 'el-icon-arrow-up'
			            : 'el-icon-arrow-down'
			        "
			        v-if="$store.state.global.searchExtend_2"
			        class="btn-2b5a95"
			        @click="onExtendClick('isSearchExtend_2')"
			        >{{ $store.state.global.searchExtendText_2 }}</el-button
			      >
			    </div>
			  </div>
			
			  <el-table
			    :data="selectTable.list"
			    style="width: 100%"
			    ref="moneyTable"
					:key="key"
			    @selection-change="handleSelectionChange"
			  >
			    <el-table-column type="selection" width="55" />
			    <el-table-column label="流水号" prop="id" align="center" />
			    <el-table-column label="真实姓名" prop="realname" align="center" />
			    <el-table-column label="所属部门" prop="departorgname" align="center" />
			    <el-table-column
			      label="所属教学点"
			      prop="schoolorgname"
			      align="center"
			    />
			  </el-table>
			  <el-pagination
			    background
			    @current-change="
			     (val, data) =>
			         handleSelectChange(val, Object.assign({}, selectSearchForm))
			     "
			    :current-page="selectPageInfo.pageindex"
			    :page-size="selectPageInfo.pagesize"
			    :page-sizes="[10, 20, 30, 40, 50]"
			    layout="total, prev, pager, next, jumper"
			    :total="selectTable.totalcount"
			  ></el-pagination>
			</el-dialog>
			
			
			<!-- 审核人6 -->
			<el-dialog
			  class="btn-2b5a95"
			  width="50%"
				v-dialogDrag
			  @close="onCloseSelect"
			  title="选择审核人"
				:close-on-click-modal='false'
			  :visible.sync="showInusernameModal6"
			  v-if="showInusernameModal6"
			  append-to-body
			>
			  <el-button
			    type="primary"
			    @click="onConfirmInusername6('showInusernameModal6')"
			    >确定</el-button
			  >
			
			  <div class="index_2 btn-2b5a95">
			    <div
			      class="l-w"
			      :style="{
			        height: $store.state.global.isSearchExtend_2
			          ? ''
			          : $store.state.global.searchFormHeight_2 + 10 + 'px',
			      }"
			    >
			      <el-form
			        label-position="right"
			        :class="
			          $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
			        "
			        :model="selectSearchForm"
							@submit.native.prevent
			      >
			        <el-form-item label="真实姓名:" prop="realname">
			          <el-input 
			        		v-model.trim="selectSearchForm.realname" 
			        		@keyup.enter.native="onSelectSearchClick(
			            selectTableUrl,
			            null,
			            Object.assign({}, selectSearchForm)
			          )"
			        		clearable />
			        </el-form-item>
			      </el-form>
			    </div>
			    <div class="r-w">
			      <el-button
			        type="primary"
			        icon="el-icon-search"
			        :loading="!$store.state.global.isEndRequest"
			        class="btn-2b5a95"
			        @click="onSelectSearchClick(
			            selectTableUrl,
			            null,
			            Object.assign({}, selectSearchForm)
			          )"
			        >搜索</el-button
			      >
						<el-button type="primary" @click="handleQuery">重置</el-button>
			      <el-button
			        type="primary"
			        :icon="
			          $store.state.global.isSearchExtend_2
			            ? 'el-icon-arrow-up'
			            : 'el-icon-arrow-down'
			        "
			        v-if="$store.state.global.searchExtend_2"
			        class="btn-2b5a95"
			        @click="onExtendClick('isSearchExtend_2')"
			        >{{ $store.state.global.searchExtendText_2 }}</el-button
			      >
			    </div>
			  </div>
			
			  <el-table
			    :data="selectTable.list"
			    style="width: 100%"
			    ref="moneyTable"
					:key="key"
			    @selection-change="handleSelectionChange"
			  >
			    <el-table-column type="selection" width="55" />
			    <el-table-column label="流水号" prop="id" align="center" />
			    <el-table-column label="真实姓名" prop="realname" align="center" />
			    <el-table-column label="所属部门" prop="departorgname" align="center" />
			    <el-table-column
			      label="所属教学点"
			      prop="schoolorgname"
			      align="center"
			    />
			  </el-table>
			  <el-pagination
			    background
			    @current-change="
			     (val, data) =>
			         handleSelectChange(val, Object.assign({}, selectSearchForm))
			     "
			    :current-page="selectPageInfo.pageindex"
			    :page-size="selectPageInfo.pagesize"
			    :page-sizes="[10, 20, 30, 40, 50]"
			    layout="total, prev, pager, next, jumper"
			    :total="selectTable.totalcount"
			  ></el-pagination>
			</el-dialog>
			
			<!-- 审核人7 -->
			<el-dialog
			  class="btn-2b5a95"
			  width="50%"
				v-dialogDrag
			  @close="onCloseSelect"
			  title="选择审核人"
				:close-on-click-modal='false'
			  :visible.sync="showInusernameModal7"
			  v-if="showInusernameModal7"
			  append-to-body
			>
			  <el-button
			    type="primary"
			    @click="onConfirmInusername7('showInusernameModal7')"
			    >确定</el-button
			  >
			
			  <div class="index_2 btn-2b5a95">
			    <div
			      class="l-w"
			      :style="{
			        height: $store.state.global.isSearchExtend_2
			          ? ''
			          : $store.state.global.searchFormHeight_2 + 10 + 'px',
			      }"
			    >
			      <el-form
			        label-position="right"
			        :class="
			          $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
			        "
			        :model="selectSearchForm"
							@submit.native.prevent
			      >
			        <el-form-item label="真实姓名:" prop="realname">
			          <el-input 
			        		v-model.trim="selectSearchForm.realname" 
			        		@keyup.enter.native="onSelectSearchClick(
			            selectTableUrl,
			            null,
			            Object.assign({}, selectSearchForm)
			          )"
			        		clearable />
			        </el-form-item>
			      </el-form>
			    </div>
			    <div class="r-w">
			      <el-button
			        type="primary"
			        icon="el-icon-search"
			        :loading="!$store.state.global.isEndRequest"
			        class="btn-2b5a95"
			        @click="onSelectSearchClick(
			            selectTableUrl,
			            null,
			            Object.assign({}, selectSearchForm)
			          )"
			        >搜索</el-button
			      >
						<el-button type="primary" @click="handleQuery">重置</el-button>
			      <el-button
			        type="primary"
			        :icon="
			          $store.state.global.isSearchExtend_2
			            ? 'el-icon-arrow-up'
			            : 'el-icon-arrow-down'
			        "
			        v-if="$store.state.global.searchExtend_2"
			        class="btn-2b5a95"
			        @click="onExtendClick('isSearchExtend_2')"
			        >{{ $store.state.global.searchExtendText_2 }}</el-button
			      >
			    </div>
			  </div>
			
			  <el-table
			    :data="selectTable.list"
			    style="width: 100%"
			    ref="moneyTable"
					:key="key"
			    @selection-change="handleSelectionChange"
			  >
			    <el-table-column type="selection" width="55" />
			    <el-table-column label="流水号" prop="id" align="center" />
			    <el-table-column label="真实姓名" prop="realname" align="center" />
			    <el-table-column label="所属部门" prop="departorgname" align="center" />
			    <el-table-column
			      label="所属教学点"
			      prop="schoolorgname"
			      align="center"
			    />
			  </el-table>
			  <el-pagination
			    background
			    @current-change="
			     (val, data) =>
			         handleSelectChange(val, Object.assign({}, selectSearchForm))
			     "
			    :current-page="selectPageInfo.pageindex"
			    :page-size="selectPageInfo.pagesize"
			    :page-sizes="[10, 20, 30, 40, 50]"
			    layout="total, prev, pager, next, jumper"
			    :total="selectTable.totalcount"
			  ></el-pagination>
			</el-dialog>
			
			<!-- 审核人8 -->
			<el-dialog
			  class="btn-2b5a95"
			  width="50%"
				v-dialogDrag
			  @close="onCloseSelect"
			  title="选择审核人"
				:close-on-click-modal='false'
			  :visible.sync="showInusernameModal8"
			  v-if="showInusernameModal8"
			  append-to-body
			>
			  <el-button
			    type="primary"
			    @click="onConfirmInusername8('showInusernameModal8')"
			    >确定</el-button
			  >
			
			  <div class="index_2 btn-2b5a95">
			    <div
			      class="l-w"
			      :style="{
			        height: $store.state.global.isSearchExtend_2
			          ? ''
			          : $store.state.global.searchFormHeight_2 + 10 + 'px',
			      }"
			    >
			      <el-form
			        label-position="right"
			        :class="
			          $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
			        "
			        :model="selectSearchForm"
							@submit.native.prevent
			      >
			        <el-form-item label="真实姓名:" prop="realname">
			          <el-input 
			        		v-model.trim="selectSearchForm.realname" 
			        		@keyup.enter.native="onSelectSearchClick(
			            selectTableUrl,
			            null,
			            Object.assign({}, selectSearchForm)
			          )"
			        		clearable />
			        </el-form-item>
			      </el-form>
			    </div>
			    <div class="r-w">
			      <el-button
			        type="primary"
			        icon="el-icon-search"
			        :loading="!$store.state.global.isEndRequest"
			        class="btn-2b5a95"
			        @click="onSelectSearchClick(
			            selectTableUrl,
			            null,
			            Object.assign({}, selectSearchForm)
			          )"
			        >搜索</el-button
			      >
						<el-button type="primary" @click="handleQuery">重置</el-button>
			      <el-button
			        type="primary"
			        :icon="
			          $store.state.global.isSearchExtend_2
			            ? 'el-icon-arrow-up'
			            : 'el-icon-arrow-down'
			        "
			        v-if="$store.state.global.searchExtend_2"
			        class="btn-2b5a95"
			        @click="onExtendClick('isSearchExtend_2')"
			        >{{ $store.state.global.searchExtendText_2 }}</el-button
			      >
			    </div>
			  </div>
			
			  <el-table
			    :data="selectTable.list"
			    style="width: 100%"
			    ref="moneyTable"
					:key="key"
			    @selection-change="handleSelectionChange"
			  >
			    <el-table-column type="selection" width="55" />
			    <el-table-column label="流水号" prop="id" align="center" />
			    <el-table-column label="真实姓名" prop="realname" align="center" />
			    <el-table-column label="所属部门" prop="departorgname" align="center" />
			    <el-table-column
			      label="所属教学点"
			      prop="schoolorgname"
			      align="center"
			    />
			  </el-table>
			  <el-pagination
			    background
			    @current-change="
			     (val, data) =>
			         handleSelectChange(val, Object.assign({}, selectSearchForm))
			     "
			    :current-page="selectPageInfo.pageindex"
			    :page-size="selectPageInfo.pagesize"
			    :page-sizes="[10, 20, 30, 40, 50]"
			    layout="total, prev, pager, next, jumper"
			    :total="selectTable.totalcount"
			  ></el-pagination>
			</el-dialog>
  </div>
</template>

<script>
import { part } from "@/utils/mixins";
import { mapActions } from "vuex";
import {
  approval_list,
	approval_delete,
	approval_save,
	approval_input,
} from "@/request/api/allChildrenProject";
import { myRequest } from "@/request/index";
import {
  selectCheck,
  confirmCallBack,
  messageTip,
  createObjParams,
  formatDare,
} from "@/utils/util";
import {
	_projectApprovals,
	_examin,
} from "@/assets/js/filedValueFlag";
import {
	_user_dialogresult,
	dic_combox,
}from "@/request/api/public";
export default {
  mixins: [part],
  components: {},
  props: {
		user_dialogresult: {
			default: () => _user_dialogresult,
		}
	},
  data() {
    return {
			examin: _examin,
      pageinfo: {
      	pageindex: 1,
      	pagesize: 10,
      },//页面查询
			dynamicValidateForm: {
				type: null,
				username1: null,
			},//表单数据
      tableRes: {},	//列表接口
      searchForm: {},
      selectTable: {},
      selectTableUrl: "",
      selectPageInfo: {
        pageindex: 1,
        pagesize: 10,
      },
      selectSearchForm: {},
			approvals: _projectApprovals,
			showAddModal: false,//增加
			showInusernameModal: false,//审核人1
			showInusernameModal2: false,//审核人2
			showInusernameModal3: false,//审核人3
			showInusernameModal4: false,//审核人4
			showInusernameModal5: false,//审核人5
			showInusernameModal6: false,//审核人6
			showInusernameModal7: false,//审核人7
			showInusernameModal8: false,//审核人8
			approvalTypeList: [], //审核类型
			dialogTitle: "", //对话框标题
			type: {
				1: '支出登记',
				2: '院校往来',
			},
			key: '',
			rules:{
					schoolorgname: [
					  { trigger: "blur", message: "必填字段", required: true },
					],
					companyorgname: [
					  { trigger: "blur", message: "必填字段", required: true },
					],
					username1: [
						{message: "必填字段", required: true },
					],
					type: [
						{message: "必填字段", required: true },
					],
			},
    };
  },
  created() {
		this.org_comboxchild();
  	this.org_combox();
		this.getDataList();
		this.dic_combox({
		  that: this,
		  typecode: "approvalType",
		  list: "approvalTypeList",
		});
		window.addEventListener("keyup", this.enterSelect);
	},
  methods: {
  	...mapActions("global", ["onExtendClick", "isExpand"]),
  	...mapActions("selectData", ["org_combox", "org_comboxchild",'dic_combox']),
		//改变分公司 change
		onChangeCompany(val, form) {
		  this[form].companyorgid = val;
		  this.org_comboxchild(val);
			this[form].schoolorgname = '';
		},
		onChangeSchool(val, form) {
		  this[form].schoolorgid = val;
			this.$forceUpdate();
		},
		enterSelect(e) {
			if(e.keyCode == 13) {
				this.getDataList();
			}
		},
		visibleType(e) {
			if(!e) {
				this.$refs.selectref.blur();
			}
		},
  	//触发所有btn方法
  	onClickBtn(methodsName) {
  		this.$options.methods[methodsName].call(this);//btnAdd ... （防止修改this指向）
  	},
  	//搜索 click
  	search() {
  		this.pageinfo.pageindex = 1;
  		this.getDataList();
  	},
		reset() {
			this.searchForm = {
				username1: null,
				username2: null,
				username3: null,
				username4: null,
				username5: null,
				username6: null,
				username7: null,
				username8: null,
				schoolorgname: null,
				type: null
			}
		},
		//重置 click
		resetQuery () {
			this.reset();
			this.getDataList();
		},
		selectQuery() {
			this.selectSearchForm = {
				realname: null
			}
		},
		handleQuery() {
			this.selectQuery();
			this.onSelectData(this.selectTableUrl, null, null);
		},
  	//列表查询 api
  	getDataList() {
  		myRequest({
  			url: approval_list,
  			data: Object.assign(this.searchForm, this.pageinfo),
  		}).then((res) => {
  			if(res.data.code === "200") {
  				this.tableRes = res.data.data;
  			}
  		})
  	},
  	//切换当前页
  	handleCurrentChange(val) {
  		this.pageinfo.pageindex = val;
  		this.getDataList();
  	},
  	//切换选项表格页
  	handleSelectChange(val,data,prop,page) {
  		this.selectPageInfo.pageindex = val;
  		this.onSelectData(
  			this.selectTableUrl,
  			null,
  			prop,
  			page
  		);
			this.onCloseSelect();
  	},
  	//刷新 click
  	btnRefresh() {
  		this.getDataList();
  	},
  	//选项表格 api
  	onSelectData(url, modal, data, prop, page) {
  		this.selectTableUrl = url;
  		myRequest({
  			url: this.selectTableUrl,
  			data: Object.assign(data || {}, this.selectPageInfo),
  		}).then((res) => {
  			if(res.data.code === "200") {
  				this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
  				this.selectTable = res.data.data;
					this.key = Math.random();
  				this[modal] = true;
  			}
  		})
  	},
  	//选项表格 搜索click
  	onSelectSearchClick(url, modal, data){
  		this.selectPageInfo.pageindex = 1
  		this.onSelectData(url, modal, data)
  	},
  	//选中表格数据改变时
  	handleSelectionChange(val) {
  		this.multipleSelection = val;
  	},
		//关闭选项框 click
		onCloseSelect() {
			this.selectPageInfo.pageindex = 1;
		},
		
		//增加
		btnAdd() {
			this.dialogTitle = "添加";
			 this.dynamicValidateForm = {
			   schoolorgid: this.$store.state.login.userinfo.schoolorgid,
			   companyorgid: this.$store.state.login.userinfo.companyorgid,
			 };
			 this.$set(
			   this.dynamicValidateForm,
			   "companyorgname",
			   this.$store.state.login.userinfo.companyorgname
			 );
			 this.$set(
			   this.dynamicValidateForm,
			   "schoolorgname",
			   this.$store.state.login.userinfo.schoolorgname
			 );
			this.org_comboxchild(this.dynamicValidateForm.companyorgid);
			this.showAddModal = true;
		},
		/* 添加--提交api */
		submitAddOrEditForm(formName){
			this.dynamicValidateForm.userid2 = this.dynamicValidateForm.userid2 || 0
			this.dynamicValidateForm.userid3 = this.dynamicValidateForm.userid3 || 0
			this.dynamicValidateForm.userid4 = this.dynamicValidateForm.userid4 || 0
			this.dynamicValidateForm.userid5 = this.dynamicValidateForm.userid5 || 0
			this.dynamicValidateForm.userid6 = this.dynamicValidateForm.userid6 || 0
			this.dynamicValidateForm.userid7 = this.dynamicValidateForm.userid7 || 0
			this.dynamicValidateForm.userid8 = this.dynamicValidateForm.userid8 || 0
			  this.$refs[formName].validate((valid) => {
			    if (valid) {
			      myRequest(
			        {
			          url: approval_save,
			          data: this.dynamicValidateForm,
			        },
			        {
			          that: this,
			          isRefTableList: true,
								
			          modal: "showAddModal",
			        }
			      );
			    }
			  });
		},
		//确认选择审核人 click
		onConfirmInusername(modal) {
		  selectCheck(this.multipleSelection, "确定审核人", false, () => {
				this.$set(
				  this.dynamicValidateForm,
				  "username1",
				  this.multipleSelection[0].realname
				);
		    this.dynamicValidateForm.userid1 = this.multipleSelection[0].id;
		    this.showInusernameModal = false;
				this.selectQuery();
				this.multipleSelection = [];
		  });
		},
		//确认选择审核人2 click
		onConfirmInusername2(modal) {
		  selectCheck(this.multipleSelection, "确定审核人", false, () => {
		    this.$set(
		      this.dynamicValidateForm,
		      "username2",
		      this.multipleSelection[0].realname
		    );
		    this.dynamicValidateForm.userid2 = this.multipleSelection[0].id;
		    this.showInusernameModal2 = false;
				this.selectQuery();
				this.multipleSelection = [];
		  });
		},
		//确认选择审核人3 click
		onConfirmInusername3(modal) {
		  selectCheck(this.multipleSelection, "确定审核人", false, () => {
		    this.$set(
		      this.dynamicValidateForm,
		      "username3",
		      this.multipleSelection[0].realname
		    );
		    this.dynamicValidateForm.userid3 = this.multipleSelection[0].id;
		    this.showInusernameModal3 = false;
				this.selectQuery();
				this.multipleSelection = [];
		  });
		},
		//确认选择审核人4 click
		onConfirmInusername4(modal) {
		  selectCheck(this.multipleSelection, "确定审核人", false, () => {
		    this.$set(
		      this.dynamicValidateForm,
		      "username4",
		      this.multipleSelection[0].realname
		    );
		    this.dynamicValidateForm.userid4 = this.multipleSelection[0].id;
		    this.showInusernameModal4 = false;
				this.selectQuery();
				this.multipleSelection = [];
		  });
		},
		//确认选择审核人5 click
		onConfirmInusername5(modal) {
		  selectCheck(this.multipleSelection, "确定审核人", false, () => {
		    this.$set(
		      this.dynamicValidateForm,
		      "username5",
		      this.multipleSelection[0].realname
		    );
		    this.dynamicValidateForm.userid5 = this.multipleSelection[0].id;
		    this.showInusernameModal5 = false;
				this.selectQuery();
				this.multipleSelection = [];
		  });
		},
		//确认选择审核人6 click
		onConfirmInusername6(modal) {
		  selectCheck(this.multipleSelection, "确定审核人", false, () => {
		    this.$set(
		      this.dynamicValidateForm,
		      "username6",
		      this.multipleSelection[0].realname
		    );
		    this.dynamicValidateForm.userid6 = this.multipleSelection[0].id;
		    this.showInusernameModal6 = false;
				this.selectQuery();
				this.multipleSelection = [];
		  });
		},
		//确认选择审核人7 click
		onConfirmInusername7(modal) {
		  selectCheck(this.multipleSelection, "确定审核人", false, () => {
		    this.$set(
		      this.dynamicValidateForm,
		      "username7",
		      this.multipleSelection[0].realname
		    );
		    this.dynamicValidateForm.userid7 = this.multipleSelection[0].id;
		    this.showInusernameModal7 = false;
				this.selectQuery();
				this.multipleSelection = [];
		  });
		},
		//确认选择审核人8 click
		onConfirmInusername8(modal) {
		  selectCheck(this.multipleSelection, "确定审核人", false, () => {
		    this.$set(
		      this.dynamicValidateForm,
		      "username8",
		      this.multipleSelection[0].realname
		    );
		    this.dynamicValidateForm.userid8 = this.multipleSelection[0].id;
		    this.showInusernameModal8 = false;
				this.selectQuery();
				this.multipleSelection = [];
		  });
		},
		//修改
		btnEdit() {
			this.dialogTitle = "修改：";
			selectCheck(this.multipleSelection, "修改", false, ()=> {
				this.editRoutePage();
			})
		},
		//修改路由页
		editRoutePage() {
			myRequest({
				url: approval_input,
				data: {
					id: this.multipleSelection[0].id,
				},
			}).then((res) => {
				if(res.data.code === "200") {
					this.dynamicValidateForm = res.data.data.vapproval;
					this.dynamicValidateForm.type = String(res.data.data.vapproval.type)
					this.showAddModal = true;
				}
			})
		},
		//删除
		btnDel() {
			selectCheck(this.multipleSelection, "删除", true, ()=> {
				confirmCallBack({
					title:"提示",
					content: "此操作将永久删除选中的数据！",
					success: () => {
						this.delTableItem(this.multipleSelection.map((i) => i.id));
					},
					fail: () => {
						messageTip({
							message:"取消操作",
							type: "info",
						});
					},
				});
			});
		},
		//删除 api
		delTableItem(idArr) {
			myRequest(
			{
				method: "post",
				url: approval_delete,
				data: this.$qs.stringify(
					{
						ids: idArr,
					},
					{
						arrayFormat: "repeat"
					}
				),
			},
			{
				isRefTableList: true,
				that: this,
			}
			)
		},
		
  }
};
</script>

<style  lang="scss">
</style>